import { DEFAULT_PAGE_SIZE } from '@w7/ui'
import {
  getVARBets,
  isInvalidBetLogsOk,
  searchIBLogs,
  toInvalidBetsResult,
} from '@/api/map/invalidBetLogs'
import type { InvalidBetsQuery, InvalidBetsResult } from './invalidBetsTypes'

/** Empty page — never invent log rows. */
function emptyInvalidBets(query: InvalidBetsQuery): InvalidBetsResult {
  const pageSize = Math.max(1, query.pageSize ?? DEFAULT_PAGE_SIZE)
  const page = Math.max(1, query.page ?? 1)
  return {
    rows: [],
    total: 0,
    page,
    pageSize,
    tab: query.tab,
  }
}

/**
 * Live CM → `getVARBets` / `searchIBLogs` (shared DB via CM-API).
 */
export async function loadInvalidBets(
  query: InvalidBetsQuery,
): Promise<InvalidBetsResult> {
  const members = (query.members ?? [])
    .map((name) => name.trim())
    .filter(Boolean)

  const sport = query.sport?.trim()
  const body = {
    page: query.page ?? 1,
    pageSize: query.pageSize ?? DEFAULT_PAGE_SIZE,
    fromDate: query.fromDate,
    toDate: query.toDate,
    playerName: members.length > 0 ? members : undefined,
    sport:
      sport && sport.toLowerCase() !== 'all' ? sport : undefined,
  }

  const live =
    query.tab === 'var-bet' ? await getVARBets(body) : await searchIBLogs(body)
  if (!isInvalidBetLogsOk(live)) return emptyInvalidBets(query)
  return toInvalidBetsResult(live, query)
}
